import {Injectable} from '@angular/core';
import {HttpService} from "../../core/services/http.service";
import {Observable, of} from "rxjs";
import {ConfirmationModel} from "../../core/models/confirmation.model";
import {CommentModel} from "../../core/models/comment.model";
import {environment} from '../../../environments/environment';
import {TimeSlotsModel} from "../../core/models/time-slots.model";
import {AppointmentModel} from "../../core/models/appointment.model";
import {TimeSlotModel} from "../../core/models/time-slot.model";

const API_URL = environment.apiUrl;

@Injectable()
export class EmbedModeService {
  private embedMode: string | null = null;
  private embedModeEnabled: boolean = false;

  setEmbedMode(mode: string | null): void {
    this.embedMode = mode;
    this.embedModeEnabled = !!mode;
  }

  getEmbedMode(): string | null {
    return this.embedMode;
  }

  isEmbedModeEnabled(): boolean {
    return this.embedModeEnabled;
  }

  closeFrameEvent() {
    if (this.isEmbedModeEnabled() &&  window && window.top) {
      window.top.postMessage(
        {closeFrame: true, reloadData: false},
        '*');
    }
  }

  reloadDataEvent() {
    if (this.isEmbedModeEnabled() && window && window.top) {
      window.top.postMessage(
        {closeFrame: false, reloadData: true},
        '*');
    }
  }

}
